import { getBaseUrl } from '../utilities/get-base-url';
var WasThisUsefulService = /** @class */ (function () {
    function WasThisUsefulService($http, baseUrl, marketLocale, siteContext) {
        this.$http = $http;
        this.baseUrl = baseUrl;
        this.marketLocale = marketLocale;
        this.siteContext = siteContext;
        if (this.baseUrl[this.baseUrl.length - 1] !== '/') {
            this.baseUrl += '/';
        }
    }
    WasThisUsefulService.prototype.sendInitialResponse = function (model) {
        var url = getBaseUrl(this.baseUrl, this.marketLocale, undefined, this.siteContext);
        return this.$http
            .post(url, model, this.buildRequestConfig())
            .then(function (response) { return response.data; });
    };
    WasThisUsefulService.prototype.sendExtraResponse = function (model, id) {
        var url = getBaseUrl(this.baseUrl, this.marketLocale, id, this.siteContext);
        return this.$http
            .put(url, model, this.buildRequestConfig())
            .then(function (response) { return response.data; });
    };
    WasThisUsefulService.prototype.buildRequestConfig = function () {
        return {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
    };
    return WasThisUsefulService;
}());
export { WasThisUsefulService };
